import http from 'axios'
import { deleteUseless } from '../../lib/formatParams/index'

export default {
  namespaced: true,
  actions: {
    // 获取省份
    GetProvince({ state }) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/GetProvince")
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 获取市
    GetCity({ state }, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/GetCity/" + params.id)
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 申请提交推广资料
    ApplyCertification({ state }, params) {
      return new Promise((resolve, reject) => {
        http.post("/v1/promoter/ApplyCertification", deleteUseless(params))
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 修改申请材料
    ReApplyCertification({ state }, params) {
      return new Promise((resolve, reject) => {
        http.post("/v1/promoter/ReApplyCertification", deleteUseless(params))
          .then(({ data }) => {
            if (data.s === 10006) {
              resolve(data)
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    // 获取当前机构申请材料
    GetCertificationInfo({ state }, params) {
      return new Promise((resolve, reject) => {
        http.get("/v1/promoter/GetCertificationInfo")
          .then(({ data }) => {
            if (data.s === 10006) {
              const { payee, cardNO, cardNoFront, cardNoReverse, sourceImg, bankCard, dueBank, subBranch, areaID, cityID, smsCode } = data.list
              const address = cityID ? [areaID, cityID] : [areaID]
              resolve({ trueName: payee, cardNO, cardNoFront, cardNoReverse, sourceImg, bankCard, dueBank, subBranch, address, smsCode })
            } else {
              reject(data)
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    }
  }
}